import { CheckoutAbTestMetricToOptimize } from "@redotech/redo-model/checkouts/checkout-ab-test-builder";
import { CheckoutExperienceZodArraySchema } from "@redotech/redo-model/integration/redo-in-shipping/ris";
import { checkoutOptimizationTreatmentStorefrontFeaturesSchema } from "@redotech/redo-model/split";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const treatmentSchema = z.object({
  id: zExt.objectId(),
  name: z.string(),
  isSpecialExistingExperienceTreatment: z.boolean(),
  allCheckoutExperiences: CheckoutExperienceZodArraySchema,
  storefrontFeatures:
    checkoutOptimizationTreatmentStorefrontFeaturesSchema.optional(),
});
export type GetCheckoutSplitDetailsTreatment = z.infer<typeof treatmentSchema>;

export const getCheckoutSplitDetails = {
  name: "getCheckoutSplitDetails" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    name: z.string(),
    description: z.string(),
    metricToOptimize: createEnum(CheckoutAbTestMetricToOptimize),
    status: createEnum(["in_progress", "concluded", "scheduled"]),
    controlTreatment: treatmentSchema,
    variantTreatments: z.array(treatmentSchema),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
  }),
};
export type GetCheckoutSplitDetailsOutput = z.infer<
  typeof getCheckoutSplitDetails.output
>;
